import React, { createContext, useContext, useState } from 'react';

// Create the context
const HeaderContext = createContext();

// Create a provider component
export const HeaderProvider = ({ children }) => {
  const [headerTitle, setHeaderTitle] = useState('');

  // You can add more header-related state here if needed in the future

  return (
    <HeaderContext.Provider value={{ headerTitle, setHeaderTitle }}>
      {children}
    </HeaderContext.Provider>
  );
};

// Create a custom hook for using the context
export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};
